import React from 'react';

const ImageSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Healing Journey Section */}
        <div className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/flagged/photo-1569744068983-6dfc2f27deb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bHxlbnwwfHx8fDE3NzMzOTE2MjF8MA&ixlib=rb-4.1.0&q=85"
                alt="Person in peaceful contemplation by water"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-4">
              <h3 className="text-3xl font-bold text-gray-900">
                Your Journey is Unique
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                There is no timeline for grief. Some days will be harder than others, and that's okay. 
                Allow yourself to feel what you're feeling without judgment. Healing doesn't mean forgetting—it 
                means learning to carry your loss while moving forward with your life.
              </p>
            </div>
          </div>
        </div>

        {/* Finding Peace Section */}
        <div className="mb-16">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-4 md:order-1">
              <h3 className="text-3xl font-bold text-gray-900">
                Finding Moments of Peace
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                While grief can feel overwhelming, moments of peace are possible. Whether through nature, 
                meditation, talking with loved ones, or simply allowing yourself to rest—these small 
                moments of calm can help you navigate the difficult days.
              </p>
            </div>
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-xl md:order-2">
              <img 
                src="https://images.unsplash.com/photo-1494459940152-1e911caa8cc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxwZWFjZWZ1bHxlbnwwfHx8fDE3NzMzOTE2MjF8MA&ixlib=rb-4.1.0&q=85"
                alt="Peaceful sunset reflection on water"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Hope and Healing Section */}
        <div>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="relative h-80 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://images.unsplash.com/photo-1542353436-312f0e1f67ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxoZWFsaW5nfGVufDB8fHx8MTc3MzM5MTYyOXww&ixlib=rb-4.1.0&q=85"
                alt="Person with arms spread in freedom and acceptance"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-4">
              <h3 className="text-3xl font-bold text-gray-900">
                Hope Exists in Healing
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                Healing from loss doesn't happen overnight, but it does happen. With time, support, and 
                self-compassion, you can find your way forward. Remember that reaching out for help is 
                a sign of strength, not weakness. You don't have to walk this path alone.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageSection;
